// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3TJ02","signatureButtonsRight":"ModalSign_signatureButtonsRight__gc2Kq"};